<template>
  <div>
    <div class="card-div">
      <div class="card">
        <div class="card-text-div">
          <div>星巴克自助代点餐</div>
          <div>账号：{{ sAccount }}</div>
          <div>余额：{{ sBalance }}</div>
        </div>
      </div>
    </div>

    <div class="box-top">
      <div class="order-mode-1" v-if="mode == 1">
        <van-button
          text="开始点饮品"
          round
          :color="this.$enum.CONSTANT.APP_THEME_COLOR"
          to="searchShop"
        />
      </div>

      <div class="order-mode-2" v-if="mode == 2">
        <div class="mode-text">因点餐高峰期系统繁忙您可以选择</div>
        <van-button
          text="获取中杯通兑券（优惠价:30元/杯）"
          round
          :color="this.$enum.CONSTANT.APP_THEME_COLOR"
          to="orderHint"
        />
        <div class="mode-text-hint">
          *遇高峰期建议选中杯券，去线下门店点餐时使用
        </div>
        <div class="mode-or-text">或</div>
        <van-button
          text="在线点单使用"
          round
          :color="this.$enum.CONSTANT.APP_THEME_COLOR"
          to="searchShop"
        />
        <div
          class="mode-text-hint"
          style="width: 190px; margin: 0 auto; margin-bottom: 30px"
        >
          *中午11:30-13:30为点餐高峰期 取餐口令可能会延迟15-30分钟
        </div>
      </div>

      <div class="order-mode-3" v-if="mode == 3">
        <van-button
          text="获取中杯通兑券（优惠价:30元/杯）"
          round
          :color="this.$enum.CONSTANT.APP_THEME_COLOR"
          to="orderHint"
        />
        <div class="mode-text-hint" style="margin: 0 auto; margin-bottom: 30px">
          *获取二维码后，在门店前台点餐时出示店员核销
        </div>
      </div>
    </div>

    <div class="grid">
      <van-grid :column-num="3" :border="false">
        <van-grid-item
          v-for="(item, index) in gridList"
          :key="index"
          :to="item.to"
        >
          <template #icon>
            <img
              class="grid-icon"
              :src="item.icon"
              @click="item.to === '' ? showCustomerServiceModel() : ''"
            />
          </template>
          <template #text>
            <div class="grid-item-title">{{ item.title }}</div>
          </template>
        </van-grid-item>
      </van-grid>
    </div>

    <div class="footer">
      <div class="tip">
        <div class="divider-div">
          <van-divider>温馨提示</van-divider>
        </div>
        <div>营业时间：{{ openTime }}-{{ closeTime }},到店前10-15分钟点餐</div>
        <div>到店在“取品台”领取,不支持外卖配送</div>
        <div>客服热线：{{ customerService }}</div>
      </div>
    </div>
    <!-- 在线客服 -->
    <van-action-sheet
      v-model="customerServiceModel"
      :round="false"
      :closeable="false"
      title="在线客服"
    >
      <div class="customer-service-model-content">
        客服热线：
        <a :href="'tel:' + customerService">{{ customerService }}</a>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  Image as VanImage,
  Button,
  ActionSheet,
  Divider,
  Notify,
} from "vant";
import { getOrderMode,getPlatformPayWay } from "@/request/api";
import store from "@/store";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { getYuedongAccount } from "@/request/api";
import PayType from "@/components/pay/PayType.vue";
export default {
  name: "home",
  computed: mapGetters(["sUserInfo", "sAccount", "sBalance", "sLocation"]),
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [ActionSheet.name]: ActionSheet,
    [Notify.name]: Notify,
    [PayType.name]: PayType,
  },
  beforeMount(){
    getOrderMode().then((res) => {
      this.mode = res.configValue;
    });
   
  },
  mounted() {
    //查询用户信息
    this.init();
    // console.log(location.protocol,location.host,location.hash,location.pathname);
    if (history && history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goback, false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.goback);
  },
  data() {
    return {
      code: "",
      showPayType: false,
      history: [],
      orderId: "",
      mode: null,
      customerServiceModel: false,
      platformCode:null,
      openTime: "8:00",
      closeTime: "21:00",
      customerService: "400-0808-910",
      gridList: [
        {
          icon: require("../assets/order.jpg"),
          title: "我的订单",
          to: "historyOrder",
        },
        {
          icon: require("../assets/card.jpg"),
          title: "兑换充值",
          to: "recharge",
        },
        {
          icon: require("../assets/user.jpg"),
          title: "个人中心",
          to: "userInfo",
        },
        {
          icon: require("../assets/vip.jpg"),
          title: "客服",
          to: "service",
        },
        {
          icon: require("../assets/card.jpg"),
          title: "优惠券",
          to: "coupon",
        },
        {
          icon: require("../assets/loginOut.png"),
          title: "注销账号",
          to: "",
        },
      ],
    };
  },

  methods: {
    ...mapMutations([
      "sSetLocation",
      "sSetUserInfo",
      "setOrderCode",
      "sSetToken",
      "sSetCouponId",
      "clearCouponId",
    ]),
    //获取用户信息
    init() {
      this.platformCode = this.$getUrlParam('id') || this.$getUrlParam('platformCode')
      // this.sSetLocation("");
      // this.clearCouponId()
      // console.log(this.sLocation, "定位位置信息");
      this.getUserInfoForToken();
    },
    //通过token查询用户信息
    getUserInfoForToken() {
      getYuedongAccount({}).then((res) => {
        this.sSetUserInfo(res);
      }).then(()=>{
        getPlatformPayWay({code:this.platformCode || '1f'}).then(res=>{
          if(res.payTypeH5 && res.payTypeWx){
            localStorage.setItem('payWay',JSON.stringify({payH5:res.payTypeH5,payWx:res.payTypeWx}))
          }else{
            localStorage.setItem('payWay',JSON.stringify({payH5:3,payWx:2}))
          }
        })
      })
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href.split("#")[0];
      let search = url.split("?")[1];
      if (search) {
        var r = search.substring(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },

    splitQueryParam(params) {
      let tempParam = [];
      if (Object.keys(params).length <= 0) return "";
      for (let key in params) {
        tempParam.push(`${key}=${params[key]}`);
      }
      return tempParam.join("&");
    },
    // 注销账号
    showCustomerServiceModel() {
      store.commit("sSetToken", "");
      localStorage.removeItem("token");
      localStorage.removeItem("openId");
      let url = window.location.href;
      let queryParam = {};
      if (this.$getUrlParam("id")) {
        queryParam.id = this.$getUrlParam("id");
      }
      if (this.$getUrlParam("ac")) {
        queryParam.ac = this.$getUrlParam("ac");
      }
      let newUrl =
        window.location.origin + "?" + this.splitQueryParam(queryParam);
      window.location.href = newUrl;
    },
    goback() {
      history.go(-3);
    },
  },
};
</script>

<style scoped>
.card-div {
  background-color: #f5f5f5;
  width: 100%;
  height: 170px;
  padding: 10px 10px;
}

.footer,
.box-top {
  text-align: center;
}
.order-mode-2 {
  padding-top: 20px;
}

.grid-icon {
  width: 50px;
  height: 50px;
}

.card {
  width: 100%;
  height: 100%;
  background-image: url(../assets/index_card_bg.jpg);
  background-size: 100% 100%;
}

.card-text-div {
  padding-left: 88px;
  padding-top: 37px;
  font-size: 15px;
  color: #c8a665;
  font-weight: 500;
}

.grid {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 0;
}

.grid-item-title {
  font-size: 12px;
  padding-top: 8px;
  padding-bottom: 10px;
  color: #666666;
}

.van-button {
  width: 80%;
  height: 50px;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.van-divider {
  font-size: 10px;
  color: #9a9a9a;
  border-color: #9a9a9a;
  line-height: 20px;
  margin: 0;
}

.divider-div {
  width: 40%;
  text-align: center;
  margin: 0 auto;
}

.tip {
  font-size: 10px;
  color: #9a9a9a;
}

.tip > div {
  min-height: 17px;
}

.customer-service-model-content {
  padding: 35px 0 85px 0;
  text-align: center;
  font-size: 15px;
}

.van-action-sheet__header {
  font-size: 17px;
  padding: 10px 0;
}

.customer-service-model-content > a {
  text-decoration: underline;
  color: #00b8d5;
  font-size: 15px;
}
.mode-text {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
.mode-text-hint {
  color: #cea559;
  font-size: 12px;
}
.mode-or-text {
  font-size: 32px;
  color: #333;
  padding-top: 10px;
}
</style>
